import { render, staticRenderFns } from "./ProductSize.vue?vue&type=template&id=ee19f14e&scoped=true&"
import script from "./ProductSize.vue?vue&type=script&lang=js&"
export * from "./ProductSize.vue?vue&type=script&lang=js&"
import style0 from "./ProductSize.vue?vue&type=style&index=0&id=ee19f14e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee19f14e",
  null
  
)

export default component.exports